module.exports = __webpack_public_path__ + "media/images/cards/cc-discover-cfbf43338d112ee0e681014e39b6c465.svg";